import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
// import axios from "axios";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Table,
  UncontrolledTooltip,
  Spinner,
  Pagination,
  PaginationItem,
  PaginationLink,
  FormGroup,
  Modal,
  Label,
} from "reactstrap";

import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";

import Select from "react-select";

// actions
import {
  resetDepartments,
  resetError,
  getDepartments,
  deleteDepartment,
} from "../../store/actions";

import { useDispatch, useSelector } from "react-redux";

//i18n
import { withTranslation } from "react-i18next";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation";

// Toast
import toastr from "toastr";
import "toastr/build/toastr.min.css";

const Departments = ({ t }) => {
  const dispatch = useDispatch();
  const qtdDefault = 7;

  const {
    dataDepartment,
    dataDepartmentDelete,
    loadingDepartment,
    loadingDepartmentDelete,
    errorDepartment,
    successDepartment,
  } = useSelector((state) => state.Department);

  const [page, setPage] = useState(1);
  const [modal, setModal] = useState(false);
  const [departmentId, setDepartmentId] = useState("");
  const [departmentName, setDepartmentName] = useState("");

  const [nameFilter, setNameFilter] = useState("");
  const [emailFilter, setEmailFilter] = useState("");
  const [slugFilter, setSlugFilter] = useState("");

  const [notFound, setNotFound] = useState(false);

  const [companyId, setCompanyId] = useState();

  const showToast = (type, message) => {
    toastr[type](message);
  };
  toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: true,
    onclick: null,
    showDuration: "200",
    hideDuration: "200",
    timeOut: "2000",
    extendedTimeOut: "2000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
    onHidden: () =>
      successDepartment && dispatch(resetDepartments()) && handleFilter(),
  };

  const handleFilter = (name, email, slug) => {
    setNameFilter(name);
    setEmailFilter(email);
    setSlugFilter(slug);
    setPage(1);
    dispatch(
      getDepartments(companyId, page, qtdDefault, name, email, slug, true)
    );
  };

  const handleDelete = () => {
    dispatch(deleteDepartment(departmentId, companyId));
  };

  const toggleModal = () => {
    setModal(!modal);
  };

  const setDepartmentIdName = (department) => {
    setDepartmentId(department.id);
    setDepartmentName(department.name);
  };

  const handlePage = (value) => {
    setPage(value);
    dispatch(
      getDepartments(
        companyId,
        value,
        qtdDefault,
        nameFilter,
        emailFilter,
        slugFilter,
        true
      )
    );
  };

  const handlePreviousPage = () => {
    if (page > 1) {
      handlePage(page - 1);
    }
  };

  const handleNextPage = () => {
    if (dataDepartment && dataDepartment.paging) {
      if (page < dataDepartment.paging.length) {
        handlePage(page + 1);
      }
    }
  };

  const optionsCompany = () => {
    let companies = [];

    dataDepartment?.form?.client &&
      dataDepartment.form.client.forEach((company, key) =>
        companies.push({ key: key, value: company.id, label: company.name })
      );

    return companies;
  };

  useEffect(() => {
    dispatch(getDepartments(null, null, null, null, null, null, true));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (dataDepartmentDelete && dataDepartmentDelete.message) {
      showToast("success", t(dataDepartmentDelete.message));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [successDepartment]);

  useEffect(() => {
    if (errorDepartment && typeof errorDepartment === "object") {
      errorDepartment.map(
        //TODO: remover esta verificação quando o backend enviar array vazio com status 200 quando nao ha objetos
        (error) =>
          error.value !== "departments_id not found" &&
          showToast("error", t(error.value))
      );
      dispatch(resetError());
    } else {
      if (errorDepartment) {
        showToast("error", t(errorDepartment));
        dispatch(resetError());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorDepartment]);

  useEffect(() => {
    if (dataDepartment && dataDepartment.idCompany) {
      setCompanyId(dataDepartment.idCompany);
    }
    if (dataDepartment !== null) {
      setNotFound(false);
    } else {
      setNotFound(true);
    }
  }, [dataDepartment]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            mainPath="/dashboard"
            path="/departments"
            title={t("Dashboard")}
            breadcrumbItem={t("Departments")}
          />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <AvForm
                    onValidSubmit={(event, values) => {
                      if (companyId) {
                        handleFilter(values.name, values.email, values.slug);
                      } else {
                        showToast("info", t("Please select a company"));
                      }
                    }}
                  >
                    <Row>
                      <Col xs="12" md="4" xl="2" className="mb-3">
                        <FormGroup>
                          <AvField
                            label={t("Name")}
                            id="name"
                            name="name"
                            type="text"
                            className="form-control"
                            placeholder={t("Name") + "..."}
                            validate={{
                              pattern: {
                                value: "/^[A-Za-z0-9 áàâãéèêíïóôõöúç]*$/i", // only letters, numbers and space
                                errorMessage: t(
                                  "Name must be composed only with letter and numbers"
                                ),
                              },
                              minLength: {
                                value: 3,
                                errorMessage: t("Min 3 characters"),
                              },
                              maxLength: {
                                value: 60,
                                errorMessage: t("Max 60 characters"),
                              },
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col xs="12" md="4" xl="2" className="mb-3">
                        <FormGroup>
                          <AvField
                            label={t("Email")}
                            id="email"
                            name="email"
                            type="text"
                            className="form-control"
                            placeholder={t("Email") + "..."}
                            validate={{
                              minLength: {
                                value: 3,
                                errorMessage: t("Min 3 characters"),
                              },
                              maxLength: {
                                value: 60,
                                errorMessage: t("Max 60 characters"),
                              },
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col xs="12" md="4" xl="2" className="mb-3">
                        <FormGroup>
                          <AvField
                            label={t("Slug")}
                            id="slug"
                            name="slug"
                            type="text"
                            className="form-control"
                            placeholder={t("Slug") + "..."}
                            value={slugFilter}
                            validate={{
                              minLength: {
                                value: 3,
                                errorMessage: t("Min 3 characters"),
                              },
                              maxLength: {
                                value: 60,
                                errorMessage: t("Max 60 characters"),
                              },
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col xs="12" md="4" xl="2" className="mb-3">
                        <FormGroup className="select2-container">
                          <Label className="control-label">
                            {t("Company")}
                          </Label>
                          <Select
                            classNamePrefix="select2-selection"
                            className="w-100 mb-3"
                            placeholder={t("Company") + "..."}
                            options={optionsCompany()}
                            isLoading={loadingDepartment ? true : false}
                            isSearchable
                            onChange={(e) => {
                              setCompanyId(e.value);
                            }}
                            noOptionsMessage={() =>
                              t("No matching records found")
                            }
                            value={optionsCompany().find(
                              (item) => item.value === companyId
                            )}
                          />
                        </FormGroup>
                      </Col>
                      <Col
                        xs="12"
                        md="4"
                        lg="auto"
                        className="mt-auto mb-3 filter-create-btn"
                      >
                        <Button
                          type="submit"
                          color="primary"
                          className="waves-effect waves-light w-100 mb-3 mr-3"
                        >
                          <i className="mdi mdi-feature-search-outline mr-1"></i>
                          {t("Search")}
                        </Button>
                      </Col>
                      <Col
                        xs="12"
                        md="4"
                        lg="auto"
                        className="mt-auto mb-3 ml-auto filter-create-btn"
                      >
                        <div className="text-sm-right mb-3" id="new-department">
                          <Link to={`/company/${companyId}/department`}>
                            <Button
                              type="button"
                              color="success"
                              className={"waves-effect waves-light w-100 mr-2 "}
                              disabled={!companyId}
                            >
                              <i className="mdi mdi-plus mr-1"></i>
                              {t("Add Department")}
                            </Button>
                          </Link>
                        </div>
                      </Col>
                    </Row>
                  </AvForm>

                  <div className="table-responsive">
                    <PerfectScrollbar>
                      <Table className="table table-centered table-nowrap">
                        <thead className="thead-light">
                          <tr>
                            <th>{t("Name")}</th>
                            <th>{t("Email")}</th>
                            <th>{t("Slug")}</th>
                            <th>{t("Action")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {loadingDepartment ? (
                            <tr>
                              <td colSpan="20" align="center">
                                <Spinner
                                  size="sm"
                                  animation="border"
                                  style={{
                                    marginTop: "40px",
                                    height: "50px",
                                    width: "50px",
                                  }}
                                />
                              </td>
                            </tr>
                          ) : notFound ? (
                            <tr>
                              <td colSpan="20" align="center">
                                {t("Click search to show the records")}
                              </td>
                            </tr>
                          ) : dataDepartment &&
                            dataDepartment.departments &&
                            dataDepartment.departments.length > 0 ? (
                            dataDepartment.departments.map(
                              (department, key) => (
                                <tr key={key}>
                                  <td>{department.name}</td>
                                  <td>{department.email}</td>
                                  <td>{department.slug}</td>
                                  <td>
                                    <Link
                                      to={`/company/${companyId}/department/${department.id}`}
                                      className="text-primary text-center"
                                      id="edit"
                                    >
                                      <i
                                        className="mdi mdi-pencil font-size-18 px-2"
                                        id="edittooltip"
                                      ></i>
                                      <UncontrolledTooltip
                                        placement="auto"
                                        target="edittooltip"
                                      >
                                        {t("Edit")}
                                      </UncontrolledTooltip>
                                    </Link>
                                    {/* TODO: add custom styles to css file */}
                                    <span style={{ cursor: "pointer" }}>
                                      <i
                                        className="mdi mdi-window-close text-danger font-size-18 px-2"
                                        id="deletetooltip"
                                        onClick={() => {
                                          toggleModal();
                                          setDepartmentIdName(department);
                                        }}
                                      ></i>
                                      <UncontrolledTooltip
                                        placement="auto"
                                        target="deletetooltip"
                                      >
                                        {t("Delete")}
                                      </UncontrolledTooltip>
                                    </span>
                                  </td>
                                </tr>
                              )
                            )
                          ) : (
                            <tr>
                              <td colSpan="20" align="center">
                                {t("No matching records found")}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                      <Modal isOpen={modal || loadingDepartmentDelete}>
                        <div className="modal-body font-size-18 text-center">
                          {t("Do you want to delete the department")}
                          <strong> {departmentName}</strong>?
                        </div>
                        <div className="modal-footer">
                          <button
                            type="button"
                            onClick={toggleModal}
                            className="btn btn-danger waves-effect"
                            data-dismiss="modal"
                            style={{ backgroundColor: "#f14646" }}
                          >
                            {t("No")}
                          </button>
                          {loadingDepartmentDelete ? (
                            <button
                              type="button"
                              className="btn btn-secondary waves-effect waves-light"
                              disabled
                            >
                              <Spinner size="sm" animation="border" />
                            </button>
                          ) : (
                            <button
                              type="button"
                              className="btn btn-secondary waves-effect waves-light"
                              onClick={() => {
                                toggleModal();
                                if (departmentId) handleDelete();
                              }}
                            >
                              {t("Yes")}
                            </button>
                          )}
                        </div>
                      </Modal>
                    </PerfectScrollbar>
                  </div>

                  {dataDepartment &&
                  dataDepartment.paging &&
                  dataDepartment.paging.length > 1 ? (
                    <Pagination className="pagination pagination-rounded justify-content-end my-2">
                      <PaginationItem onClick={handlePreviousPage}>
                        <PaginationLink previous />
                      </PaginationItem>

                      {dataDepartment &&
                        dataDepartment.paging &&
                        dataDepartment.paging.map((value, index) => {
                          return (
                            <PaginationItem
                              key={index}
                              onClick={() => {
                                handlePage(value);
                              }}
                              active={page === value ? true : false}
                            >
                              <PaginationLink
                                key={index}
                                style={{ display: "inline" }}
                              >
                                {value}
                              </PaginationLink>
                            </PaginationItem>
                          );
                        })}
                      <PaginationItem onClick={handleNextPage}>
                        <PaginationLink next />
                      </PaginationItem>
                    </Pagination>
                  ) : (
                    ""
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(Departments);
